import { PatientCard, PatientPaymentControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  cardId: string;
  patientCard: PatientCard;
  xTENANTID?: string;
}

/**
 * Updates editable details on a saved card (card holder name, expiry, billing
 * details). Sensitive card data stays masked and is not sent.
 *
 * @author [Atish Bagate]
 */
export const useUpdatePatientCard = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientPaymentControllerApi(getConfigObject()).updateCard(
      params.cardId,
      params.patientCard,
      params.xTENANTID
    )
  );
